<section>
  <div class="title-section">
    <div class="title">{{title}}</div>
    <ng-container *ngIf="typeOfLegacy=='Google'">
      <img src="../../assets/img/default/help-btn.svg" alt="" width="35"
        ngbTooltip="Trusted contacts are notified if your account becomes inactive and can access data you’ve shared."
        placement="right">
    </ng-container>
    <ng-container *ngIf="typeOfLegacy=='Apple'">
      <img src="../../assets/img/default/help-btn.svg" alt="" width="35"
        ngbTooltip="Legacy Contacts can access your data for 3 years after the first approved request, then your account is permanently deleted."
        placement="right">
    </ng-container>
    <ng-container *ngIf="typeOfLegacy=='Facebook'">
      <img src="../../assets/img/default/help-btn.svg" alt="" width="35"
        ngbTooltip="Legacy Contacts can manage your memorialised profile but can’t log in or read messages."
        placement="right">
    </ng-container>
  </div>
  <div>{{label}}</div>
</section>

<section>
  <ng-container *ngFor="let person of peopleToNotify; let i = index">
    <div class="person-to-notify">
      <input type="text" [(ngModel)]="person.name" (ngModelChange)="savePersonChanges()" placeholder="Name">
      <input type="email" [(ngModel)]="person.email" (ngModelChange)="savePersonChanges()"
        placeholder="Relation to you">
      <ng-container *ngIf="typeOfLegacy=='Google'">
        <select [(ngModel)]="person.notificationType" (ngModelChange)="savePersonChanges()">
          <option value="All" disabled selected>Data to be shared</option>
          <option value="All">All</option>
          <option value="Some">Some</option>
          <option value="None">None</option>
        </select>
      </ng-container>
      <ng-container *ngIf="typeOfLegacy=='Facebook'">
        <div class="facebook-container">
          <select [(ngModel)]="person.notificationType" (ngModelChange)="savePersonChanges()">
            <option value="Yes" disabled selected>Data archive access</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
          <img src="../../assets/img/default/help-btn.svg" alt="" width="35"
            ngbTooltip="Choose whether your Legacy Contact can download what you’ve shared on Facebook after you pass."
            placement="top">
        </div>
      </ng-container>
      <ng-container *ngIf="typeOfLegacy=='Apple'">
          <select [(ngModel)]="person.notificationType" (ngModelChange)="savePersonChanges()">
            <option value="Yes" disabled selected>Access key shared</option>
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
      </ng-container>
    </div>
    <button class="btn primary-sml-btn remove-person" *ngIf="peopleToNotify.length > 1"
      (click)="$event.preventDefault(); removePerson(i)">Remove</button>
  </ng-container>

  <ng-container *ngIf="doNotAddAnotherPerson==false">
    <div class="add-save-btns">
      <button class="btn primary-sml-btn add-another-person" (click)="$event.preventDefault(); addPerson()">Add another
        person</button>
    </div>
  </ng-container>
</section>